import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import { platformMessages } from 'ml-components-platform-react';

import metadata from './MLPUPVehicleListPopup.metadata.json5';
import styles from './MLPUPVehicleListPopup.module.scss';

const MLPUPVehicleListPopup = (props) => {
    const {
        vehicles,
        replaceVehicle,
        editVehicle,
        removeVehicle,
        onCancel,
        viewModelService
    } = props;

    const translator = useTranslator();
    const vehicleTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('PUPVehicleType_PUE');
    const bodyTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('BodyType');

    const getTypeKeyDescription = useCallback((typeKeyName) => {
        return translator({
            id: typeKeyName,
            defaultMessage: typeKeyName
        });
    }, [translator]);

    const getExcludedCellValue = (excluded) => {
        if (excluded === true) {
            return translator(platformMessages.mlYes);
        }
        if (excluded === false) {
            return translator(platformMessages.mlNo);
        }
        return '';
    };

    const onReplaceVehicle = useCallback((callbackProps) => {
        replaceVehicle(vehicles[callbackProps.index], onCancel);
    }, [replaceVehicle, vehicles, onCancel]);

    const onEditVehicle = useCallback((callbackProps) => {
        editVehicle(vehicles[callbackProps.index], onCancel);
    }, [editVehicle, vehicles, onCancel]);

    const onRemoveVehicle = useCallback((callbackProps) => {
        removeVehicle(vehicles[callbackProps.index], onCancel);
    }, [removeVehicle, vehicles, onCancel]);

    const generateOverrides = () => {
        const overrides = vehicles.map((item, index) => {
            return {
                [`typeCell${index}`]: {
                    className: `cell font-weight-bold ${_.get(item, 'error', false) ? 'error-help-text' : ''}`
                },
                [`typeErrorAlertIcon${index}`]: {
                    visible: _.get(item, 'error', false)
                },
                [`type${index}`]: {
                    content: item.type ? getTypeKeyDescription(vehicleTypelist.getCode(item.type).name) : null
                },
                [`year${index}`]: {
                    content: item.year
                },
                [`make${index}`]: {
                    content: item.make
                },
                [`model${index}`]: {
                    content: item.model
                },
                [`bodyType${index}`]: {
                    content: item.bodyType ? getTypeKeyDescription(bodyTypelist.getCode(item.bodyType).name) : null
                },
                [`trim${index}`]: {
                    content: item.trim_ML
                },
                [`vin${index}`]: {
                    content: item.vin
                },
                [`excluded${index}`]: {
                    content: getExcludedCellValue(item.excluded)
                },
                [`replaceVehicle${index}`]: {
                    'aria-labelledby': `year${index} make${index} model${index} bodyType${index} trim${index} vin${index}`
                },
                [`editVehicle${index}`]: {
                    'aria-labelledby': `year${index} make${index} model${index} bodyType${index} trim${index} vin${index}`
                },
                [`removeVehicle${index}`]: {
                    'aria-labelledby': `year${index} make${index} model${index} bodyType${index} trim${index} vin${index}`
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    const overrides = {
        vehicleContentContainer: {
            visible: vehicles.length > 0
        },
        vehicleIterable: {
            data: vehicles
        },
        ...generateOverrides()
    };

    const resolvers = {
        resolveCallbackMap : {
            onReplaceVehicle,
            onEditVehicle,
            onRemoveVehicle
        },
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );

};

MLPUPVehicleListPopup.propTypes = {
    vehicles: PropTypes.array,
    replaceVehicle: PropTypes.func,
    editVehicle: PropTypes.func,
    removeVehicle: PropTypes.func,
    onCancel: PropTypes.func
};

export default MLPUPVehicleListPopup;
